import { createSlice } from "@reduxjs/toolkit";
import { ResearchReportDetailRes } from "core/http/service/researchReport/resTypes";
import { ReduxStateType } from "redux-store/types";
interface InitialState {
  data: ResearchReportDetailRes;
  status: ReduxStateType;
}

const initialState: InitialState = {
  data: {},
  status: ReduxStateType.INIT,
};

const getDetailResearchReportSlice = createSlice({
  name: "getDetailReseachReport",
  initialState,
  reducers: {
    getDetailRRStart: (state, action) => {
      state.status = ReduxStateType.LOADING;
    },
    getDetailRRSuccess: (state, action) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload.data;
    },
    getDetailRRFailed: (state) => {
      state.status = ReduxStateType.ERROR;
      state.data = {};
    },
    resetGetDetailRR: (state) => initialState,
  },
});

export const {
    getDetailRRStart,
    getDetailRRSuccess,
    getDetailRRFailed,
    resetGetDetailRR,
} = getDetailResearchReportSlice.actions;

export default getDetailResearchReportSlice.reducer;
